export type SavingsUpdatedAtSource = {
  __typename?: string | null
  updatedAt?: Date | string | null
} | null

/** Poll interval while waiting for a missed/delayed savings SSE notification. */
export const UTILITY_SAVINGS_RECALC_FALLBACK_INTERVAL_MS = 3_000

/** Max fallback polls before forcing settled (avoids a permanent loader). */
export const UTILITY_SAVINGS_RECALC_FALLBACK_MAX_ATTEMPTS = 10

export const getSavingsUpdatedAt = (
  savings: SavingsUpdatedAtSource,
): string | null => {
  if (!savings?.updatedAt) return null

  return String(savings.updatedAt)
}

/**
 * Clear the proactive utility-savings pending flag only when the client has
 * loaded a Savings snapshot newer than the one observed when recalc was queued.
 * Without a baseline, keep pending until the bounded fallback settles — a
 * late GraphQL refetch must not clear against an unknown pre-recalc snapshot.
 */
export const shouldClearUtilitySavingsRecalculating = (
  baselineUpdatedAt: string | null,
  nextUpdatedAt: string | null,
): boolean => {
  if (!baselineUpdatedAt || !nextUpdatedAt) return false

  return nextUpdatedAt !== baselineUpdatedAt
}
